@import "~@govbr-ds/core/src/components/footer/mixins";
@include footer-logo;

:host {
  display: block;
}

:host(.partner) {
  display: inline-block;
}

.logo {
  &.partner {
    margin-left: var(--spacing-scale-3x);
    text-decoration: none;
    padding: 0;
  }

  a {
    text-decoration: none;

    &:hover,
    &:focus {
      background-image: none;
    }
  }
}
